<div class="container">
  <div *ngIf="challengeDetailListElaborated && challengeDetailListElaborated.length > 0; else emptyList">

    <table #levelsTable data-testid="levelsTable" class="detail-tab levelTable">

      <thead>
        <tr>
          <th class="pl-4 text-center">{{ 'challenge.id' | translate }}</th>
          <th class="pl-4 text-center">{{ 'challenge.levelName' | translate }}</th>
          <th class="text-center">{{ 'challenge.controlAcm' | translate }}</th>
          <th class="text-center">{{ 'challenge.minimumThreshold' | translate }}</th>
          <th class="text-center">{{ 'challenge.maxThreshold' | translate }}</th>
          <th class="text-center">{{ 'challenge.pushNotify' | translate }}</th>
          <th class="text-center">{{ 'challenge.pushNotifyText' | translate }}</th>
          <th class="text-center">{{ 'challenge.numRewards' | translate }}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let challengeDetail of challengeDetailListElaborated; let i = index">

          <!-- ID -->
          <td class="pl-4 text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.id }}
          </td>

          <!-- Level Name -->
          <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.levelName }}
          </td>

          <!-- ACM -->
          <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.acmDescription }}
          </td>

          <!-- Minimum -->
          <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.minimumTrashold }}
          </td>

          <!-- Maximum -->
          <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.maximumTrashold }}
          </td>

          <!-- Push Notify -->
          <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.pushNotify === '0' ? 'No' : 'Si' }}
          </td>

          <!-- Push Notify Text -->
          <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.pushNotifyText }}
          </td>

             <td class="text-center" [ngClass]="checkExpiredChallengeDetail()">
            {{ challengeDetail.numRewards }}
          </td>


          <!-- Actions -->
          <td>
            <div class="detail-btn-container" #menuContainer>
              <div class="d-flex flex-row">
                <!-- Menu Button -->
                <button class="btn-details" data-testid-generic="challengeDetail-details"
                  [attr.data-testid]="'challengeDetail-details' + challengeDetail.id"
                  (click)="toggleMenu(challengeDetail.id, i, $event)">
                  <i class="pi pi-ellipsis-h margin-fit"></i>
                </button>
              
                <!-- Eye Button -->
                <button class="btn-details" (click)="onEditGifts(challengeDetail); $event.stopPropagation()"
                  title="{{ 'challenge.editCreateRewards' | translate }}" [ngClass]="{ 'gift-green': challengeDetail.numRewards > 0 }">
                  <i class="fa fa-gift" style="margin-top: 1px"></i>
                </button>
              
              
                <!-- Dropdown Menu -->
                <div class="dropdown-menu" *ngIf="challengeDetail.menuActivated === true">

                      <button class="dropdown-item-creation" data-testid-generic="challengeDetail-info"
                    [attr.data-testid]="'challengeDetail-info' + challengeDetail.id"
                    (click)="onInfoLevel(challengeDetail); closeAllDropdowns()" [disabled]="isInfoLevelDisabled()"
                    [ngClass]="{'not-permitted': isInfoLevelDisabled()}">
                    {{ 'challenge.info_challenge_level' | translate }}
                  </button>
                  <button class="dropdown-item-creation" data-testid-generic="challengeDetail-edit"
                    [attr.data-testid]="'challengeDetail-edit' + challengeDetail.id"
                    (click)="onEditLevel(challengeDetail, i); closeAllDropdowns()" [disabled]="isEditLevelDisabled()"
                    [ngClass]="{'not-permitted': isEditLevelDisabled()}">
                    {{ 'challenge.edit_challenge_level' | translate }}
                  </button>
                  <button class="dropdown-item-creation" data-testid-generic="challengeDetail-delete"
                    [attr.data-testid]="'challengeDetail-delete' + challengeDetail.id"
                    (click)="onDeleteLevel(challengeDetail, i); closeAllDropdowns()" [disabled]="isEditLevelDisabled()"
                    [ngClass]="{'not-permitted': isEditLevelDisabled()}">
                    {{ 'challenge.delete_challenge_level' | translate }}
                  </button>

                  <button 
    class="dropdown-item-creation" 
    data-testid-generic="challengeDetail-notification-status"
    [attr.data-testid]="'challengeDetail-notification-status' + challengeDetail.id"
    (click)="openNotificationStatus(challengeDetail); closeAllDropdowns()">
    {{ 'common.view_status' | translate }}
</button>
                </div>
              </div>
            </div>

            <!-- Overlay invisibile che chiude il menu -->
            <div class="menu-backdrop" *ngIf="showMenu" (click)="closeAllDropdowns()">
            </div>
          </td>

        </tr>
      </tbody>

    </table>
  </div>

  <!-- CREATE NEW -->
  <div class="create-btn-container">
    <div class="opener-btn-container">
      <button data-testid="createNewLevel" class="new-level-button" (click)="onSearchClusterToAdd()"
        [disabled]="isEditLevelDisabled()" [ngClass]="{'disabled-button': isEditLevelDisabled()}">
        <i class="pi pi-plus"></i>
        {{ 'challenge.create_new_level' | translate }}
      </button>

    </div>
  </div>
</div>


<!-- DELETE DIALOG -->
<p-dialog class="custom-dialog" header="{{ 'challenge.confirm_delete' | translate }}" [(visible)]="displayDeleteDialog"
  [modal]="true" [closable]="false">

  <div>
    {{ 'challenge.confirm_delete_level' | translate }}
    <span *ngIf="levelToDelete">
      {{ levelToDelete.levelName }} ?
    </span>
  </div>

  <div class="custom-footer">
    <button pButton type="button" icon="pi pi-times" (click)="closePopupDelete()"
      label="{{ 'common.cancel' | translate }}">
    </button>

    <button pButton type="button" icon="pi pi-check" (click)="onDefinitiveDelete()"
      label="{{ 'common.confirm' | translate }}" style="margin-left: .25em">
    </button>
  </div>
</p-dialog>


<!-- CLUSTER POPUP -->
<p-dialog [(visible)]="menuCreationActive" [style]="{ width: '90vw', height: 'auto' }"
  [contentStyle]="{ overflow: 'auto' }" [width]="1500" [responsive]="true"
  [header]="'challenge.add_cluster_to_list' | translate" showEffect="fade" [modal]="true">
</p-dialog>


<!-- EMPTY LIST -->
<ng-template #emptyList>
  <div class="empty-list-container d-flex justify-content-center">
    <span class="empty-list-message" style="padding: 20px;">
      {{ 'challenge.empty_challenge_details' | translate }}
    </span>
  </div>
</ng-template>





// WEBPACK FOOTER //
// ./src/app/views/challenge/challeng-levels/challenge-levels.component.html